import React, { Component } from "react";
import AccordionItem from "./AccordionItem/AccordionItem";

import minusRoundIcon from '../../images/minus-round.svg';
import addRoundIcon from '../../images/add-circle.svg';

export default class AccordionList extends Component {
  handleReveal = evt => {
    [...this.refs.accordion.children].forEach(item => {
      item.children[1].classList.add('hide');
      item.children[0].children[2].src = addRoundIcon;
    })

    evt.target.parentNode.nextSibling.classList.remove('hide');
    evt.target.nextSibling.nextSibling.src = minusRoundIcon;
  };

  render() {
    return (
      <div ref="accordion">
        {this.props.content.map(({ heading, description, image, height }, index) => (
          <AccordionItem
            heading={heading}
            description={description}
            image={image}
            key={index}
            id={index}
            click={(evt) => this.handleReveal(evt)}
            height={height}
          />
        ))}
      </div>
    );
  }
}
